export default __webpack_public_path__ + "static/media/restaurant-active.721ea825.svg";